module.exports = {
  path: 'login',
  getComponent(nextState, cb) {
    require.ensure([], require => {
      cb(null, require('./components/Login'));
    });
  }
};



// WEBPACK FOOTER //
// ./routes/login/index.js